import React from "react"
import Flickity from "react-flickity-component"
import { fetch } from "../../services/dataStore"
import { SessionStore } from "../../services/sessionStore"
import { MenuItem } from "../MenuItem"

interface MenuCarouselProps {
  count?: number,
  weekOf?: string,
  categories?: string[],
  designVariation?: boolean,
  cacheKey?: string
}

interface MenuCarouselState {
  items: object[]
}

class MenuCarouselInner extends React.Component<MenuCarouselProps, MenuCarouselState> {
  static defaultProps: MenuCarouselProps = {
    count: 6,
    weekOf: "",
    categories: [],
    designVariation: false,
    cacheKey: "menuCarousel",
  }

  constructor(props = {}) {
    super(props)
    this.renderItem = this.renderItem.bind(this)

    this.state = {
      items: [],
    }
  }

  componentDidMount() {
    this.loadData()
  }

  getCacheKey() {
    const propValues = Object.values(this.props)
    return `items-${propValues.join("-")}`
  }

  isDesktop() {
    return !matchMedia("screen and (max-width: 576px)").matches
  }

  private async fetchData() {
    const { count, weekOf, categories } = this.props
    try {
      const queryString = `{
        menuItems(
          count: ${count},
          weekOf: "${weekOf}",
          categories: ${JSON.stringify(categories)}
        ){
          allergens
          title
          image
          customizable
          classifications {
            name
            icon
          }
          defaultVariant {
            name
            visible
          }
          variantOptions {
            name
          }
        }
      }`

      const { menuItems } = await fetch(queryString)
      return menuItems
    } catch (error) {
      return []
    }
  }

  private async loadData() {
    const cacheKey = this.getCacheKey()
    let data = SessionStore.fetch(cacheKey)

    if (!data) {
      data = await this.fetchData()
      SessionStore.save(cacheKey, data)
    }

    this.setState({ items: data })
  }

  renderVariation() {
    const { designVariation } = this.props

    if (designVariation) {
      return "b-variation"
    }
  }

  renderItem(item: object, index: number) {
    const { designVariation } = this.props
    const data = { ...item, designVariation }
    return (
      <div className="w-full md:w-1/2 lg:w-1/3 mb-2 p-4 min-h-full flex items-stretch outer-article" key={index}>
        <MenuItem {...data} />
      </div>
    )
  }

  render() {
    const designVariation = this.renderVariation()
    const { items } = this.state
    const options = {
      wrapAround: true,
      initialIndex: 1,
      draggable: true,
      prevNextButtons: this.isDesktop(),
    }

    return (
      <Flickity className={designVariation} options={options}>
        { items.map(this.renderItem) }
      </Flickity>
    )
  }
}

export function MenuCarousel(props: MenuCarouselProps) {
  return <MenuCarouselInner {...props} />
}
